import * as React from 'react';
import { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Modal,
  Row,
} from 'reactstrap';
import {
  IGlobalContextProps,
  withGlobalContext,
} from 'src/context/global.context';
import { authenticate } from 'src/services';
import { Svg } from '../Svg';

interface ILoginModalProps {
  isOpen: boolean;
  toggleLoginModal: () => void;
  toggleResetPasswordModal: () => void;
  toggleSignupModal: () => void;
}

const LoginModal: React.SFC<
  ILoginModalProps & IGlobalContextProps & RouteComponentProps
> = ({
  context,
  history,
  isOpen,
  toggleLoginModal,
  toggleSignupModal,
  toggleResetPasswordModal,
}) => {
  const [state, setState] = useState({
    disabled: false,
    invalid: {
      email: false,
      inactive: false,
      initial: false,
      password: false,
    },
    login: { email: '', password: '' },
  });

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      login: {
        ...state.login,
        [(e.target as any).name]: (e.target as any).value,
      },
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<Element>) => {
    if (e.key === 'Enter' && !state.disabled) {
      handleAuthenticate();
    }
  };

  const handleAuthenticate = async () => {
    const { email, password } = state.login;
    setState({
      ...state,
      disabled: true,
    });
    try {
      const loginResponse = await authenticate(email, password);
      if (loginResponse) {

        if(localStorage.getItem('beadvize-IsCreating')){
         localStorage.removeItem('beadvize-IsCreating');
        } 
     
        context.updateUser();
        toggleLoginModal();
        history.push('/dashboard/');
        setState({
          disabled: false,
          invalid: {
            email: false,
            inactive: false,
            initial: false,
            password: false,
          },
          login: { email: '', password: '' },
        });
      }
    } catch (error) {
      if (error && error.response && error.response.status === 404) {
        setState({
          disabled: false,
          invalid: {
            email: true,
            inactive: false,
            initial: false,
            password: false,
          },
          login: { email: '', password: '' },
        });
      } else if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errorCode === 'initial_user'
      ) {
        setState({
          disabled: false,
          invalid: {
            email: true,
            inactive: false,
            initial: true,
            password: false,
          },
          login: { email: '', password: '' },
        });
      } else if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errorCode === 'inactive_user'
      ) {
        setState({
          disabled: false,
          invalid: {
            email: true,
            inactive: true,
            initial: false,
            password: false,
          },
          login: { email: '', password: '' },
        });
      } else {
        setState({
          disabled: false,
          invalid: {
            email: false,
            inactive: false,
            initial: false,
            password: true,
          },
          login: { email: '', password: '' },
        });
      }
    }
  };

  const handleSignupClick = () => {
    closeSignupModal();
    toggleSignupModal();
  };

  const handlePasswordClick = () => {
    closeSignupModal();
    toggleResetPasswordModal();
  };

  const closeSignupModal = () => {
    setState({
      disabled: false,
      invalid: {
        email: false,
        inactive: false,
        initial: false,
        password: false,
      },
      login: { email: '', password: '' },
    });
    toggleLoginModal();
  };

  return (
    <Modal className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg fill='dark' src='close' width={16} onClick={closeSignupModal} />
      </div>
      <div className='d-flex justify-content-between align-items-center pl-5 pr-5'>
        <h3>
          Connectez
          <br />
          vous
        </h3>
        <div className='d-flex flex-column'>
          <span className='text-primary'>Je n'ai pas de compte</span>
          <Button
            className='btn-sm text-uppercase text-white bg-primary border-0 mt-2'
            onClick={handleSignupClick}
          >
            Inscription
          </Button>
        </div>
      </div>
      <Container className='p-5' style={{ zIndex: 1 }}>
        <FormGroup>
          <Input
            type='email'
            name='email'
            placeholder='E-mail'
            invalid={
              !!state.invalid.inactive ||
              !!state.invalid.initial ||
              !!state.invalid.email ||
              !!state.invalid.password
            }
            value={state.login.email}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
          {!!state.invalid.inactive && (
            <FormFeedback>Aucun compte n'est associé à cet e-mail</FormFeedback>
          )}
          {!!state.invalid.initial && (
            <FormFeedback>
              Votre compte doit être validé avant de vous connecter
            </FormFeedback>
          )}
        </FormGroup>
        <FormGroup>
          <Input
            className='mt-3'
            type='password'
            name='password'
            placeholder='Mot de passe'
            invalid={
              (!!state.invalid.email || !!state.invalid.password) &&
              !(state.invalid.inactive || state.invalid.initial)
            }
            value={state.login.password}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
          <FormFeedback>Oups ! Veuillez réessayer</FormFeedback>
        </FormGroup>
        <Row>
          <Col xs='6' />
          <Col xs='6'>
            <Link to='/' onClick={handlePasswordClick}>
              <span className='text-dark float-right'>
                <u>Mot de passe oublié ?</u>
              </span>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col xs='6' />
          <Col xs='6'>
            <Button
              className='text-uppercase text-white bg-primary float-right border-0 mt-3'
              disabled={state.disabled}
              onClick={handleAuthenticate}
            >
              Valider
            </Button>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};

export const LoginModalWithGlobalContext = withGlobalContext(
  withRouter(LoginModal)
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/LoginModal.tsx